<template>
  <div class="flex items-center">
    <button
      class="button bg-white color-2 bn br-100 w-32px h-32px outline-0 pointer hover--fill-color-2 hover-bg-color-2"
      :disabled="decrementDisabled"
      @click="decrement"
    >
      <svg
        class="v-mid"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="32"
        height="32"
        viewBox="0 0 32 32"
      >
        <defs>
          <path id="a-decrement" d="M0 0h2v10H0z" />
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path d="M21 15v2H11v-2z" fill="#D8D8D8" fill-rule="nonzero" />
          <g transform="rotate(90 3 18)">
            <mask id="b-decrement" fill="#fff">
              <use xlink:href="#a-decrement" />
            </mask>
            <g class="fill-color-2" fill="#E1A724" mask="url(#b-decrement)">
              <path d="M-15-11h32v32h-32z" />
            </g>
          </g>
        </g>
      </svg>
    </button>

    <input
      class="bn outline-0 tc w-40px bg-light pv2 mh2"
      type="text"
      :disabled="inputDisabled"
      :min="min"
      :max="max"
      :step="step"
      v-model.number="currentValue"
      @blur="currentValue = value"
      @keydown.esc="currentValue = value"
      @keydown.enter="currentValue = value"
      @keydown.up.prevent="increment"
      @keydown.down.prevent="decrement"
    />

    <button
      class="button bg-white color-2 bn br-100 w-32px h-32px outline-0 pointer hover--fill-color-2 hover-bg-color-2"
      :disabled="incrementDisabled"
      @click="increment"
    >
      <svg
        class="v-mid"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="32"
        height="32"
        viewBox="0 0 32 32"
      >
        <defs>
          <path id="a" d="M17 15h4v2h-4v4h-2v-4h-4v-2h4v-4h2v4z" />
        </defs>
        <g fill="none" fill-rule="evenodd">
          <mask id="b" fill="#fff">
            <use xlink:href="#a" />
          </mask>
          <use fill="#D8D8D8" xlink:href="#a" />
          <g class="fill-color-2" fill="#E1A724" mask="url(#b)">
            <path d="M0 0h32v32H0z" />
          </g>
        </g>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "NumberInput",

  props: {
    disabled: Boolean,
    max: {
      type: Number,
      default: Infinity
    },
    min: {
      type: Number,
      default: 0
    },
    value: {
      required: true
    },
    step: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      currentValue: this.value,
      decrementDisabled: false,
      incrementDisabled: false,
      inputDisabled: false
    }
  },

  watch: {
    value(val) {
      this.currentValue = val
    }
  },

  methods: {
    increment() {
      if (this.disabled || this.incrementDisabled) {
        return
      }

      let newVal = this.currentValue + 1 * this.step
      this.decrementDisabled = false

      this._updateValue(newVal)
    },

    decrement() {
      if (this.disabled || this.decrementDisabled) {
        return
      }

      let newVal = this.currentValue + -1 * this.step
      this.incrementDisabled = false

      this._updateValue(newVal)
    },

    _updateValue(newVal) {
      const oldVal = this.currentValue

      if (oldVal === newVal || typeof this.value !== "number") {
        return
      }
      if (newVal <= this.min) {
        newVal = this.min
        this.decrementDisabled = true
      }
      if (newVal >= this.max) {
        newVal = this.max
        this.incrementDisabled = true
      }
      this.currentValue = newVal
      this.$emit("input", this.currentValue)
    }
  },

  mounted() {
    if (this.value == this.min) {
      this.decrementDisabled = true
    }
  }
}
</script>

<style>
.button {
  vertical-align: middle;
}
</style>

